import React from "react";
import "../css/common.scss";
import check from "../img/check.png"
import Navbar from "./Navbar";
import { useLocation } from 'react-router-dom';
import Footer from "./Footer";
const ThankYouPage = () => {

  const location = useLocation();
  const message = location.state?.message ;
  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "50vh",
    // backgroundColor: "#f0f8ff",
    fontFamily: "'Arial', sans-serif",
    color: "#333",
    textAlign: "center",
  };

  const headingStyle = {
    fontSize: "1.5rem",
    // fontWeight: "bold",
    // color: "#0d6efd",
    marginBottom: "0.75rem",
  };

  const paragraphStyle = {
    fontSize: "0.75rem",
    marginBottom: "0.5rem",
  };

  const buttonStyle = {
    marginTop: "1rem",
    padding: "10px 20px",
    fontSize: "1rem",
    color: "#fff",
    backgroundColor: "#0d6efd",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    textDecoration: "none",
  };

  return (
    <>
    <div className="fullbody container container-50 main-content">
    <Navbar/>
    <div className="thanks-page" style={containerStyle}>
    
      <div class="thank-you-icon">
            <img src={check} alt="Checkmark" />
      </div>
      {message==1?
      <>
      <h4>Thank You for Your Submission! </h4>
      <p>We have received your details and will process them shortly.</p>
      </>:
      <>
      <h4>Thank You for Your Efforts! </h4>
      <p>Due to some internal error we cant't proceed now.</p>
      </>
      }
      {/* <p style={paragraphStyle}>We appreciate your time and effort!</p> */}
      {/* <a href="/doc_scanner" style={buttonStyle}>
        Go to Home
      </a> */}
    </div>
    </div>
    <Footer/>
    </>
  );
};

export default ThankYouPage;
